
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SkyConditions',
  props: {
    conditions: {
      type: String,
      required: true,
    },
  },
  computed: {
    getConditions():string {
      return `${String(this.conditions)}/10`;
    },
  },
});
